const pricingEvents = (() => {
  const listeners = [];
  const cacheKey = 'pricingDataCompressed';


  const format = (amount, multiplier, currencyCode, locale) => {
    const value = amount / multiplier;
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      useGrouping: true,
      notation: 'standard',
      currency: currencyCode.toUpperCase(),
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: value % 1 === 0 ? 0 : 2,
    }).format(value);
  };



  const updatePricing = async () => {
    const test = true;
    const saveText = getI18n('save');
    const vsmonthly = getI18n('vsmonthly');
    const perMonth = getI18n('perMonth');
    const bAnnually = getI18n('bAnnually');
    let pricing;

    const sitename = getSiteNameForStripe();


    const retryFetch = async (url, attempt = 1, maxRetries = 10) => {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ sitename })
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
      } catch (err) {
        if (attempt >= maxRetries) throw err;
        const delay = Math.min(5000, 100 * Math.pow(2, attempt - 1));
        await new Promise(resolve => setTimeout(resolve, delay));
        return retryFetch(url, attempt + 1, maxRetries);
      }
    };


    try {
      if (!test && sessionStorage.getItem(cacheKey)) {
        const decoded = decodeAndInflate(sessionStorage.getItem(cacheKey));
        pricing = JSON.parse(decoded);
      } else {
        pricing = await retryFetch(getApiUrl('getpricing', 'geoapi'));
        const encoded = deflateAndEncode(JSON.stringify(pricing));
        sessionStorage.setItem(cacheKey, encoded);
      }


      const starterMonthly = pricing.find(p => p.interval === 'month' && p.plan === 'Starter Plan');
      const starterYearly = pricing.find(p => p.interval === 'year' && p.plan === 'Starter Plan');
      const proMonthly = pricing.find(p => p.interval === 'month' && p.plan === 'Pro Plan');
      const proYearly = pricing.find(p => p.interval === 'year' && p.plan === 'Pro Plan');


      const calculateSavings = (monthlyAmount, yearlyAmount) => {
        const monthlyTotal = monthlyAmount * 12;
        return Math.round(((monthlyTotal - yearlyAmount) / monthlyTotal) * 100);
      };

      const applyPricing = (monthlyPlan, yearlyPlan, prefix) => {
        if (!monthlyPlan || !yearlyPlan) {
          console.warn(`❌ Missing pricing for ${prefix}`);
          return;
        }

        const locale = yearlyPlan.locale || yearlyPlan.countryCodes?.[0] || yearlyPlan.countryCode || 'en-US';
        const currency = yearlyPlan.currency;
        const countryCode = yearlyPlan.countryCodes?.[0] || yearlyPlan.countryCode;
        const planName = yearlyPlan.plan;

        const monthlyFormatted = format(monthlyPlan.amount, monthlyPlan.multiplier, currency, locale);
        const yearlyFormatted = format(yearlyPlan.amount, yearlyPlan.multiplier, currency, locale);
        const perMonthFromYearlyFormatted = format(
          yearlyPlan.amount / 12,
          yearlyPlan.multiplier,
          currency,
          locale
        );
        const savePercent = calculateSavings(
          monthlyPlan.amount / monthlyPlan.multiplier,
          yearlyPlan.amount / yearlyPlan.multiplier
        );

        const monthlyContainer = document.getElementById(`${prefix}MonthlyContainer`);
        const yearlyContainer = document.getElementById(`${prefix}YearlyContainer`);
        if (monthlyContainer) {
          const spinner = document.getElementById(`${prefix}MonthlyContainerSpinner`);
          if (spinner) spinner.remove();
          monthlyContainer.innerHTML = `
            <div class="prices-monthly-rate">
              ${monthlyFormatted} <span class="prices-monthly-label text-token-text-tertiary per-month">${perMonth}</span>
            </div>`;
        }

        if (yearlyContainer) {
          const spinner = document.getElementById(`${prefix}YearlyContainerSpinner`);
          if (spinner) spinner.remove();
          yearlyContainer.innerHTML = `
            <div class="prices-monthly-rate">
              ${perMonthFromYearlyFormatted} <span class="prices-monthly-label text-token-text-tertiary per-month">${perMonth}</span>
            </div>
            <div class="prices-monthly-label text-token-text-tertiary text-sm billed-annually">
              ${yearlyFormatted} ${bAnnually}
            </div>
            <div class="inline-flex items-center text-xs font-semibold rounded-full px-2 py-1 bg-red-500 sale-button text-white">
              ${saveText} ${savePercent}% ${vsmonthly}
            </div>
          `;
        }

        const planAnchor = document.querySelector(`[data-plan-id="${prefix}PlanCard"]`);
        if (planAnchor) {
          planAnchor.setAttribute('data-plan-countrycode', countryCode || '');
          planAnchor.setAttribute('data-plan-name', planName);
          planAnchor.setAttribute('data-plan-locale', locale);
        }

        console.log(`\nCheck if the currency format is correct for country code ${countryCode.toUpperCase()} and convert to USD – give results in table format with currency format correct or not also in the column`);
        console.log(`${prefix.toUpperCase()} Plan → Monthly: ${monthlyFormatted} / Yearly: ${yearlyFormatted} (Per Month from Yearly: ${perMonthFromYearlyFormatted}, Save ${savePercent}%)`);

      };

      applyPricing(starterMonthly, starterYearly, 'starter');
      applyPricing(proMonthly, proYearly, 'pro');

      // Free Plan: Always 0.00 formatted using locale
      const fallbackLocale = starterMonthly?.locale || proMonthly?.locale || 'en-US';
      const fallbackCurrency = starterMonthly?.currency || proMonthly?.currency || 'usd';
      const formattedZero = format(0, 1, fallbackCurrency, fallbackLocale);

      const freeMonthly = document.getElementById('freeMonthlyContainer');
      const freeYearly = document.getElementById('freeYearlyContainer');
      const freeMonthlySpinner = document.getElementById('freeMonthlyContainerSpinner');
      const freeYearlySpinner = document.getElementById('freeYearlyContainerSpinner');

      if (freeMonthlySpinner) freeMonthlySpinner.remove();
      if (freeYearlySpinner) freeYearlySpinner.remove();

      if (freeMonthly) {
        freeMonthly.innerHTML = `
          <div class="prices-monthly-rate">
            ${formattedZero} <span class="prices-monthly-label text-token-text-tertiary per-month">${perMonth}</span>
          </div>`;
      }

      if (freeYearly) {
        freeYearly.innerHTML = `
          <div class="prices-monthly-rate">
            ${formattedZero} <span class="prices-monthly-label text-token-text-tertiary per-month">${perMonth}</span>
          </div>
          <div class="prices-monthly-label text-token-text-tertiary text-sm billed-annually">
            ${formattedZero} ${bAnnually}
          </div>`;
      }
    } catch (e) {
      console.error('❌ Failed to load or apply pricing:', e);
    }
  };

  const handleMonthlyClick = () => {
    const monthlyBtn = document.getElementById('monthlyBtn');
    const yearlyBtn = document.getElementById('yearlyBtn');
    const banner = document.getElementById('saveWithEarlyPlanBanner');
    if (!monthlyBtn || !yearlyBtn) return;

    monthlyBtn.style.backgroundColor = 'var(--background-color-second-path)';
    monthlyBtn.classList.remove('text-gray-500');
    monthlyBtn.classList.add('active-text-button');

    yearlyBtn.style.backgroundColor = 'var(--body-background-color)';
    yearlyBtn.classList.remove('active-text-button');
    yearlyBtn.classList.add('text-gray-500');

    ['free', 'starter', 'pro'].forEach(plan => {
      const monthly = document.getElementById(`${plan}MonthlyContainer`);
      const yearly = document.getElementById(`${plan}YearlyContainer`);
      if (monthly) monthly.classList.remove('hidden');
      if (yearly) yearly.classList.add('hidden');

      const anchor = document.querySelector(`[data-plan-id="${plan}PlanCard"]`);
      if (anchor) anchor.setAttribute('data-active-interval', 'month');
    });
    if (banner) banner.classList.remove('banner-hide');
    sessionStorage.setItem('selectedPlan', 'monthly');
  };

  const handleYearlyClick = () => {
    const monthlyBtn = document.getElementById('monthlyBtn');
    const yearlyBtn = document.getElementById('yearlyBtn');
    const banner = document.getElementById('saveWithEarlyPlanBanner');
    if (!monthlyBtn || !yearlyBtn) return;

    yearlyBtn.style.backgroundColor = 'var(--background-color-second-path)';
    yearlyBtn.classList.remove('text-gray-500');
    yearlyBtn.classList.add('active-text-button');

    monthlyBtn.style.backgroundColor = 'var(--body-background-color)';
    monthlyBtn.classList.remove('active-text-button');
    monthlyBtn.classList.add('text-gray-500');

    ['free', 'starter', 'pro'].forEach(plan => {
      const monthly = document.getElementById(`${plan}MonthlyContainer`);
      const yearly = document.getElementById(`${plan}YearlyContainer`);
      if (monthly) monthly.classList.add('hidden');
      if (yearly) yearly.classList.remove('hidden');

      const anchor = document.querySelector(`[data-plan-id="${plan}PlanCard"]`);
      if (anchor) anchor.setAttribute('data-active-interval', 'year');
    });
    if (banner) banner.classList.add('banner-hide');
    sessionStorage.setItem('selectedPlan', 'yearly');

  };

  // Function to deflate and encode the content
  const deflateAndEncode = (content) => {
    const deflatedContent = pako.deflate(content, { to: 'string' });
    return btoa(deflatedContent);
  };

  // Function to safely decode Base64 and inflate using Pako
  const decodeAndInflate = (encodedContent) => {
    try {
      if (!encodedContent || typeof encodedContent !== 'string') {
        throw new Error('Invalid Base64 input: Empty or non-string value.');
      }

      const normalizedBase64 = encodedContent.replace(/-/g, '+').replace(/_/g, '/');

      const binaryData = typeof window !== 'undefined'
        ? Uint8Array.from(atob(normalizedBase64), c => c.charCodeAt(0))
        : Uint8Array.from(Buffer.from(normalizedBase64, 'base64'));

      const inflatedContent = new TextDecoder().decode(pako.inflate(binaryData));
      return inflatedContent;
    } catch (error) {
      console.error('❌ Error decoding and inflating content:', error);
      throw new Error('Failed to decode and inflate content.');
    }
  };


  const addListener = (element, event, handler) => {
    if (element) {
      element.addEventListener(event, handler);
      listeners.push({ element, event, handler });
    }
  };

  const removeAllListeners = () => {
    listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    listeners.length = 0;
  };

  const init = () => {
    const monthlyBtn = document.getElementById('monthlyBtn');
    const yearlyBtn = document.getElementById('yearlyBtn');

    addListener(monthlyBtn, 'click', handleMonthlyClick);
    addListener(yearlyBtn, 'click', handleYearlyClick);
    const savedPlan = sessionStorage.getItem('selectedPlan');
    if (savedPlan === 'yearly') {
      handleYearlyClick();
    } else {
      handleMonthlyClick(); // default
    }

    updatePricing();
  };

  const unload = () => {
    removeAllListeners();
  };

  return {
    init,
    unload,
  };
})();

export default pricingEvents;
